import type { SVGProps } from 'react';

const SvgDoubleChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.8346 12L10.8346 16L14.8346 20" stroke="currentColor" strokeWidth={1.5} />
    <path d="M20.8346 12L16.8346 16L20.8346 20" stroke="currentColor" strokeWidth={1.5} />
  </svg>
);

export default SvgDoubleChevronLeft;
